// src/services/concoursService.js
import api from "./api";

const ConcoursService = {
    // Get all concours
    getAll() {
        return api.get("/concours");
    },

    // Get a single concours by ID
    get(id) {
        return api.get(`/concours/${id}`);
    },

    // Create a new concours
    create(data) {
        return api.post("/concours", data);
    },

    // search concours by nationalId
    searchByNationalId(nationalId) {
        return api.get(`/search/concours/${nationalId}`);
    },

    searchByNationalIdAndBirthDate(data) {
        return api.post("/searchConcoursData", data);
    },
};

export default ConcoursService;
